import React from 'react';
import { useStyles } from '../../../lib/hooks/useStyles';
import theme from '../../../lib/themes/linkpick/new_theme';
import { useRouter } from '@webapps/reactjs-tech-components';
import { Tooltip } from '../Tooltip';
import { Button } from '@material-ui/core';

export const AuthGoogleLinkedin = ({
  variant = 'google',
  disabled,
  tooltipTitle = "Seulement disponible pour apprenant"
}) => {
  const { classes } = useStyles(styles);
  const { push } = useRouter();

  const { NX_REDIRECT_URI, NX_OAUTH_URL, NX_COGNITO_OAUTH_CLIENT_ID } = process.env;

  const url = new URL(`${NX_OAUTH_URL}/oauth2/authorize`);
  const scopes = [
    'email',
    'profile',
    'openid'
  ];

  url.searchParams.append('identity_provider', variant === 'google' ? 'Google' : 'LinkedIn');
  url.searchParams.append('scope', scopes.join(' '));
  url.searchParams.append('access_type', 'offline');
  url.searchParams.append('response_type', 'CODE');
  url.searchParams.append('redirect_uri', `${NX_REDIRECT_URI}/oauth2/${variant}`);
  url.searchParams.append('client_id', `${NX_COGNITO_OAUTH_CLIENT_ID}`);

  const handleClick = (e) => {
    if (disabled) {
      e.preventDefault();
      return;
    }
    window.location.href = url.href;
  };

  const button = (
    <Button
      className={classes.button}
      disabled={disabled}
      onClick={handleClick}
    >
      {variant === 'google' ? (
        <svg className={classes.icon} width="24" height="24" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.716v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" fill="#4285F4" />
          <path d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" fill="#34A853" />
          <path d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" fill="#FBBC05" />
          <path d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335" />
        </svg>
      ) : (
        <svg className={classes.icon} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" fill="#0077B5" />
        </svg>
      )}
    </Button>
  );

  return (
    <div title={tooltipTitle} disabled={disabled} placement="top"
      style={{
        width: "50%"
      }}>
      {button}
    </div>
  );
};

const styles = () => ({
  button: theme.components.AuthGoogleLinkedin.button,
  icon: theme.components.AuthGoogleLinkedin.icon
}); 